import Axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Patents = () => {
  const [patentsList, setPatentsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const [totalPages, setTotalPages] = useState(1); // 전체 페이지 수
  const navigation = useNavigate();

  const moveDetail = (idx) => {
    navigation(`/patents/detail/${idx}`);
    window.location.reload();
  };
  //프로젝트 페이징처리
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  //페이지 변경 시 DATA호출
  useEffect(() => {
    Axios.get(
      `http://micronpharm.com/api/get/patents_paging?page=${currentPage}`
    )
      .then((res) => {
        setPatentsList(res.data.paging);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currentPage]);

  return (
    <div className="sub-wrap">
      <div className="inner_page_title">Patents</div>
      <div className="patents_content">
        {patentsList.map((patent, idx) => (
          <div className="patents_img_box" key={(currentPage - 1) * 10 + idx}>
            <img
              className="patents_img"
              onClick={() => moveDetail(patent.idx)}
              src={`http://micronpharm.com/uploads/${patent.image}`}
            />
            <div className="patents_text_box">
              <div className="patents_text">{patent.title}</div>
              <div className="patents_text date">{patent.formatDate}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="pagination_box">
        <button onClick={() => handlePagination(1)}>{`<<`}</button>
        <button
          onClick={() => {
            if (currentPage > 1) {
              handlePagination(currentPage - 1);
            }
          }}
        >
          {`<`}
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            onClick={() => handlePagination(i + 1)}
            className={currentPage === i + 1 ? "active" : ""}
          >
            {i + 1}
          </button>
        ))}
        <button
          onClick={() => {
            if (currentPage < totalPages) {
              handlePagination(currentPage + 1);
            }
          }}
        >
          {`>`}
        </button>
        <button onClick={() => handlePagination(totalPages)}>{`>>`}</button>
      </div>
    </div>
  );
};

export default Patents;
